import {
    CALENDAR_ROUTE,
    CALENDAR_PLAYER_ROUTE,
    CALENDAR_DUPLICATE_ROUTE,
    DOOR_DROP_ROUTE
} from './constants';
import http from '../../utils/httpService';
import { getCookie } from '../../utils/cookieService';


/**
 *
 * @param title
 * @param lang
 */
const requestCalendarCreation = ( title, lang ) => {
    return http.request( CALENDAR_ROUTE, 'POST', { title, lang_id: lang } );
};
/**
 *
 * @param title
 * @param lang
 * @param calendarID
 */
const requestCalendarDuplication = ( title, lang, calendarID ) => {
    return http.request( CALENDAR_DUPLICATE_ROUTE + `/${ calendarID }`, 'POST', { title, lang_id: lang } );
};
/**
 *
 * @param page
 * @param tenant
 */
const requestAllCalendars = ( page, tenant ) => {
    const route = CALENDAR_ROUTE + `?page=${ page }&tenant=${ tenant }`;
    return http.request( route, 'GET' );
};
/**
 *
 * @param calendarID
 */
const requestCalendar = calendarID => {
    const route = CALENDAR_ROUTE + `/${ calendarID }`;
    return http.request( route, 'GET' );
};
/**
 *
 * @param calendarID
 * @param key
 */
const requestPlayerCalendar = ( calendarID, key ) => {
    const uuid = getCookie( 'uuid' );
    const route = CALENDAR_PLAYER_ROUTE + `/${ calendarID }`;
    return http.request( route, 'POST', { uuid_front: uuid, key: key } );
};
/**
 *
 * @param calendarID
 * @param object
 */
const requestUpdateCalendar = ( calendarID, object ) => {
    const route = CALENDAR_ROUTE + `/${ calendarID }`;
    return http.request( route, 'PUT', object );
};
/**
 *
 * @param id
 */
const requestDeleteCalendar = id => {
    const route = CALENDAR_ROUTE + `/${ id }`;
    return http.request( route, 'DELETE' );
};
/**
 *
 * @param typeQuiz
 * @param page
 * @param tenant
 * @param search
 * @param filter
 */
const requestCalendarFilter = ( typeQuiz, page, tenant, search, filter ) => {
    const route = CALENDAR_ROUTE + `?type=${ typeQuiz }&page=${ page }&tenant=${ tenant }&search=${ search }&filter=${ filter }`;
    return http.request( route, 'GET' );
};
/**
 *
 * @param calendarID
 * @param result
 * @returns {*}
 */
const requestDoorDrop = ( calendarID, result ) => {
    const route = DOOR_DROP_ROUTE + `/${ calendarID }`;
    return http.request( route, 'POST', result );
};

export {
    requestDoorDrop,
    requestCalendarCreation,
    requestAllCalendars,
    requestCalendar,
    requestUpdateCalendar,
    requestPlayerCalendar,
    requestDeleteCalendar,
    requestCalendarFilter,
    requestCalendarDuplication
};